import React, { useEffect, useState } from 'react';
import { DatePicker, DatePickerProps, Modal, Select, Spin } from 'antd';
import '../popup-logout/PopupLogout.scss';

import moment, { Moment } from 'moment';
const { Option } = Select;

export default function PopupChangePlan(props: any) {
	const { ModalVisible, handleCancel, handleOk, isModalOpen, bodyChangePlan, setBodyChangePlan } = props;
	const [isSpin, setIsSpin] = useState(false);
	const [plan, setPlan] = useState(bodyChangePlan?.new_plan);
	const onChangeExpiredTime: DatePickerProps['onChange'] = date => {
		if (date) {
			const isoDate = date.toISOString();
			setBodyChangePlan({ ...bodyChangePlan, plan_expired_time: isoDate });
		}
	};
	const defaultExpiredDate: Moment = moment().add(1, 'year');
	useEffect(() => {
		setBodyChangePlan({ ...bodyChangePlan, new_plan: plan });
	}, [plan]);

	return (
		<div>
			<Spin size="small" spinning={isSpin} delay={1000}>
				<Modal
					open={isModalOpen}
					destroyOnClose={true}
					visible={ModalVisible}
					onCancel={handleCancel}
					onOk={handleOk}
					okButtonProps={{ style: { backgroundColor: '#13ae81', borderColor: '#13ae81' } }}
					className="round-sm text-center"
					centered
					title="CHANGE USER PLAN"
				>
					<div className="flex items-center mb-4">
						{' '}
						{/* align items vertically */}
						<span className="mr-2 min-w-[120px] text-left">New Plan</span>
						<Select
							defaultValue={bodyChangePlan?.new_plan || 'free'}
							style={{ width: 200 }}
							onChange={e => setPlan(e)}
						>
							<Option value="free">Free</Option>
							<Option value="basic">Basic</Option>
							<Option value="advanced">Advanced</Option>
							<Option value="unlimited">Unlimited</Option>
							<Option value="premium">Premium</Option>
						</Select>
					</div>

					<div className="flex items-center">
						{' '}
						{/* align items vertically */}
						<span className="mr-2 min-w-[120px] text-left">Plan expired time</span>
						<DatePicker
							format="DD/MM/YYYY"
							style={{ width: 200 }}
							defaultValue={defaultExpiredDate}
							onChange={onChangeExpiredTime}
							disabledDate={current => current && current < moment().startOf('day')}
						/>
					</div>
				</Modal>
			</Spin>
		</div>
	);
}
